import gql from 'graphql-tag';

import {
    clientOrder,
    officeClientBasic,
    officeEmployee,
    officeNotificationConfig,
    officePaymentMethod,
    officeTariffLimits,
    organisationInfo,
    organisationLicensePayment,
    organisationTariff,
} from '../fragments';

export const clientCreated = gql`
    subscription ListenClientCreated {
        clientCreated {
            ...OfficeClientBasicFragment
        }
    }
    ${officeClientBasic}
`;

export const officeNotificationConfigUpdated = gql`
    subscription ListenOfficeNotificationConfigUpdated($officeId: Int!) {
        officeNotificationConfigUpdated(officeId: $officeId) {
            configUpdated {
                ...OfficeNotificationConfigFragment
            }
            officeId
        }
    }
    ${officeNotificationConfig}
`;

export const officeEmployeeRemoved = gql`
    subscription ListenOfficeEmployeeRemoved($officeId: Int!) {
        officeEmployeeRemoved(officeId: $officeId) {
            removedEmployee {
                ...OfficeEmployeeFragment
            }
            officeId
        }
    }
    ${officeEmployee}
`;

export const tariffLimitsUpdate = gql`
    subscription ListenTariffLimitsUpdate($officeId: Int!) {
        tariffLimitsUpdated(officeId: $officeId) {
            limits {
                ...OrganisationOfficeTariffLimitsFragment
            }
            officeId
        }
    }
    ${officeTariffLimits}
`;

export const orderPaymentsUpdated = gql`
    subscription ListenOrderPaymentsUpdated {
        orderPaymentsUpdated {
            ...ClientOrderFragment
        }
    }
    ${clientOrder}
`;

export const officePaymentMethodsUpdated = gql`
    subscription ListenOfficePaymentMethodsUpdated($officeId: Int!) {
        officePaymentMethodsUpdated(officeId: $officeId) {
            updatedMethods {
                ...OfficePaymentMethodFragment
            }
            deletedMethodIds
            officeId
        }
    }
    ${officePaymentMethod}
`;

export const organisationLastOrganisationLicensePaymentUpdated = gql`
    subscription ListenOrganisationLastOrganisationLicensePaymentUpdated($organisationId: Int!) {
        organisationLastOrganisationLicensePaymentUpdated(organisationId: $organisationId) {
            organisation {
                ...OrganisationInfo
                organisationTariff {
                    ...OrganisationTariffFragment
                }
            }
            lastOrganisationLicensePayment {
                ...OrganisationLicensePaymentFragment
            }
        }
    }
    ${organisationInfo}
    ${organisationTariff}
    ${organisationLicensePayment}
`;
